<template>
  <button
    :class="{
      'btn btn-md':!is(circle),
      'btn-primary':is(primary),
      'btn-secondary': is(secondary),
      'btn-success': is(success),
      'btn-danger': is(danger),
      'btn-info': is(info),
      'btn-warning': is(warning),
      'btn-simple': is(simple),
      'btn-default': !is(primary) && !is(secondary) && !is(success) && !is(danger) && !is(info) && !is(warning) && !is(simple),
      'btn-lg': is(lg),
      'btn-md': is(md),
      'btn-sm': is(sm),
      'btn-xs': is(xs),

      'circle-button':is(circle),

      'btn-block': is(block),

      'disabled': isLoading() || disabled ,

      'scalable-btn': isScalable(scale),

      'button-position-relative': checkIfHasNotificationBadge,
    }"
    :style="width ? `width: ${width}` : ''"

    :disabled="isLoading() || disabled"
  >
    <span v-if="icon && !isLoading()">
      <pb-icon
        class="fa-fw"
        :icon="icon"
        :style="iconSize ? `font-size: ${iconSize}px !important` : ''"
      />
    </span>
    <span v-if="img && !isLoading()">
      <img
        :src="img"
        :style="iconSize ? `width: ${iconSize}px !important` : ''"
      >
    </span>
    <slot v-if="!isLoading()" />
    <div v-else><pb-icon class="fas fa-sync-alt fa-spin fa-fw" /> AGUARDE!</div>
    <span v-if="suffixIcon && !isLoading()">
      <pb-icon class="fa-fw" :icon="suffixIcon" />
    </span>

    <abbr
      v-if="checkIfHasNotificationBadge"
      class="button-notification-badge"
      :class="{
        'button-notification-badge-top-left': notificationBadgePosition === 'top-left',
        'button-notification-badge-bottom-left': notificationBadgePosition === 'bottom-left',
        'button-notification-badge-bottom-right': notificationBadgePosition === 'bottom-right',
      }"
      :style="{ 'background-color': notificationBadgeColor }"
    >
      {{ notificationBadgeValue }}
    </abbr>
  </button>
</template>

<script>
export default {
  name: 'ProButton',

  props: {
    text: { type: String },

    primary: {},
    secondary: {},
    success: {},
    danger: {},
    info: {},
    warning: {},
    simple: {},
    scale: { type: Boolean, default: true },

    block: {},

    lg: {},
    md: {},
    sm: {},
    xs: {},

    width: { type: String, default: '' },

    icon: {},
    img: '',
    iconSize: {},
    suffixIcon: { type: String, default: '' },

    call: {},
    loading: { type: Boolean, default: false },

    circle: {},

    disabled: { type: Boolean, default: false },

    // Props to use notification badge on buttons
    notificationBadge: { type: Boolean, default: false },
    // Options: 'top-right', 'top-left', 'bottom-right', 'bottom-left'
    notificationBadgePosition: {
      type: String,
      default: 'top-right',
      validator: position => [
        'top-left',
        'top-right',
        'bottom-left',
        'bottom-right',
      ].indexOf(position) !== -1,
    },
    notificationBadgeValue: { type: [String, Number], default: '' },
    notificationBadgeColor: { type: String, default: '#ff7614' },

  },
  data() {
    return {

    };
  },

  computed: {
    checkIfHasNotificationBadge() {
      return this.notificationBadge
        || this.notificationBadgeValue;
    },
  },

  methods: {
    is(arg) {
      return !_.isUndefined(arg);
    },
    isLoading() {
      if (!_.isUndefined(this.call)) return this.call.isPending();
      return this.loading;
    },
    isScalable(arg) {
      if (arg) return true;
      return false;
    },
  },
};
</script>

<style scoped lang="scss">
button {
  outline: none !important;
  .button-notification-badge {
    position: absolute;
    top: -2px;
    right: -6px;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    overflow: hidden;
    font-size: 10px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .button-notification-badge-top-left {
    top: -2px;
    left: -6px;
  }
  .button-notification-badge-bottom-left {
    top: inherit;
    bottom: -2px;
    left: -6px;
  }
  .button-notification-badge-bottom-right {
    top: inherit;
    bottom: -2px;
    right: -6px;
  }
}
.button-position-relative {
  position: relative;
}
</style>
